import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Drawer, Form, Input, Row, Space, Spin } from "antd";
import { Component } from "react";
import "../styles/general.css";

import { POST } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";
import { uploadFile } from "../functions/upload-file";

import logger from '../../utils/logger.js';
const token = sessionStorage.getItem("auth_token");

class Category_new extends Component {
  state = {
    visible: false,
    name: "",
    eng_name: "",
    description: "",
    icon: null,
    locked: false,
    load: false
  };

  componentDidMount() {}
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleImageChange = (e) => {
    e.preventDefault();
    return this.setState({ icon: e.target.files[0] });
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    const { name, eng_name, description, icon } = this.state;

    const data = {
      name: name.toLowerCase(),
      eng_name: eng_name.toLowerCase(),
      description: description.toLowerCase()
    };

   

    if (icon === null) {
      this.setState({ load: false });
      return openNotificationWithIcon("error", "Veuillez upload l'icon");
    }

    const icon_url = await uploadFile(icon);

    if (!icon_url.data.success) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Une erreur est survenue lors de l'envoie de l'image, veuillez ressayer"
      );
    }

    const request_details = {
      type: POST,
      url: service_api,
      route: "category" + "/" + "create-category",
      data: {
        ...data,
        icon: icon_url.data.url
      },
      token: token
    };

    if (data.name.length === 0 || data.eng_name.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Vous devez remplir tous les champs"
      );
    }

    try {
await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 0);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { name, eng_name, icon, load } = this.state;
    return (
      <>
        <Button type="primary" onClick={this.showDrawer}>
          <PlusOutlined /> Ajouter
        </Button>
        <Drawer
          title="Ajouter une catégorie"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Annuler
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="name"
                  label="Nom"
                  rules={[
                    {
                      required: true,
                      title: "allergie"
                    }
                  ]}
                >
                  <Input
                    name="name"
                    placeholder="nom"
                    onChange={this.handleChange}
                    value={name}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="eng_name"
                  label="Nom anglais"
                  rules={[
                    {
                      required: true,
                      title: "food_type"
                    }
                  ]}
                >
                  <Input
                    name="eng_name"
                    placeholder="nom anglais"
                    onChange={this.handleChange}
                    value={eng_name}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="icon"
                  label="Icon"
                  rules={[
                    {
                      required: true,
                      message: "Upload is required"
                    }
                  ]}
                >
                  <Input
                    type="file"
                    accept="image/x-png,image/jpeg,image/jpg"
                    placeholder="Upload picture"
                    onChange={this.handleImageChange}
                    value={icon}
                    name="icon"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Category_new;
